import React, { memo, useEffect, useMemo } from 'react';
import { useObservable } from 'react-use-observable';

import { Mask } from 'v2/components/Shared/ValuesVisibility';
import { numberToBRL } from 'v2/helpers/money';
import { financialStatementBlockedService } from 'v2/services/financialStatement/blocked';
import type { ListOrder } from 'v2/services/financialStatement/statement';

import ContentTable from '../ContentTable';

type Props = {
  order: ListOrder;
  shouldDisableSortBtn: (...args: any[]) => any;
};

function Blocked({ order, shouldDisableSortBtn }: Props) {
  useObservable(() => financialStatementBlockedService.loadData(order), [order]);

  const [balance] = useObservable(() => financialStatementBlockedService.getTotalBalance(), []);
  const [entries] = useObservable(() => financialStatementBlockedService.getFinancialStatementBlocked(), [], []);
  const [pagination] = useObservable(() => financialStatementBlockedService.getPaginationResponse(), []);
  const [isLoading] = useObservable(() => financialStatementBlockedService.isLoading(), []);

  const handlePagination = useMemo(
    () => ({
      onChangeRowsPerPage: (perPage: number) => {
        financialStatementBlockedService.setPagination({
          ...pagination,
          ...{ per_page: perPage, current_page: 1, order }
        });
        document.getElementById('blocked_table').scrollIntoView();
      },
      onChangePage: (page: number) => {
        financialStatementBlockedService.setPagination({ ...pagination, ...{ current_page: page, order } });
        document.getElementById('blocked_table').scrollIntoView();
      }
    }),
    [pagination, order]
  );

  useEffect(() => {
    if (!entries) return;
    shouldDisableSortBtn(!entries?.length);
  }, [entries, shouldDisableSortBtn]);

  return (
    <>
      {!!entries?.length && !isLoading && (
        <div className='mb-5 flex justify-end max-sm:flex-col [&>div]:flex [&>div]:items-center'>
          <div>
            <span className='pl-4 text-base'>Total em lançamentos bloqueados:</span>
            <strong className='ml-2.5 inline-block font-bold'>
              <Mask>{!isLoading && (numberToBRL(balance) || '-')}</Mask>
            </strong>
          </div>
        </div>
      )}
      <ContentTable
        id='blocked_table'
        balanceLabel='Valor no dia'
        data={entries}
        pagination={pagination}
        handlePagination={handlePagination}
        loading={isLoading}
        showBlockedDetails
      />
    </>
  );
}

export default memo(Blocked);
